export { default as github } from './github.png'
export { default as email } from './email.png'
export { default as linkedin } from './linkedin.png'




// WEBPACK FOOTER //
// ./src/layouts/images/footer/index.js